// extracted by mini-css-extract-plugin
module.exports = {"largeBrownBulletsHealth":"LargeBrownBullets_largeBrownBulletsHealth__cIwfw","chakra-collapse":"LargeBrownBullets_chakra-collapse__6zgcb"};